module.exports = "/fonts/tarra-picturemark-d-372ce309f4184c6cfcae8a12d55dcca0.svg";